export enum TaggingRuleActionType {
  ADD_TAG = 'add tag',
  SET_CATEGORY = 'set category',
  SET_SUB_CATEGORY = 'set subcategory',
  // SET_ACCOUNT = 'set account',
  SET_COUNTERPARTY = 'set counterparty',
  SET_OVERRIDE_DESCRIPTION = 'set override description',
  SET_SIGN = 'set sign',
}
